{
  "connection": {
    "welcomeMessage": "¡Bienvenido, {{firstName}}!",
    "description": "Configura Chirpee en 15 minutos y empieza a recopilar información en tiempo real de tus empleados.",
    "pill": {
      "setupNow": "Configurar ahora",
      "connected": "Conectado",
      "completed": "Completado"
    },
    "options": {
      "ssoConnected": {
        "title": "Conecta tu SSO",
        "description": "Configura el inicio de sesión único para gestionar el acceso de tu organización.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Gestionar"
      },
      "hrisConnected": {
        "title": "Conecta tu organigrama",
        "description": "Importa la estructura de tu organización para habilitar flujos de trabajo automatizados.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Configurar"
      },
      "messagingConnected": {
        "title": "Conecta la herramienta de comunicación",
        "description": "Recoge opiniones de los empleados a través de las plataformas de comunicación del equipo.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Configurar"
      },
      "billingSetup": {
        "title": "Configurar facturación",
        "description": "Añade tu información de facturación y elige un plan que se adapte a tus necesidades.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Configurar"
      },
      "branding": {
        "title": "Branding de la empresa",
        "description": "Personaliza la imagen de tu empresa para una experiencia de trabajo coherente.",
        "tooltipTitle": "Texto de ayuda",
        "buttonLabel": "Configurar"
      }
    }
  },
  "billing": {
    "backToGettingStarted": "Volver a Primeros pasos",
    "title": "Configurar facturación",
    "description": "Selecciona la opción de facturación que mejor se adapte a tu organización.",
    "currencyLabel": "Moneda:",
    "currencyPlaceholder": "Moneda",
    "taxDisclaimer": "Todos los precios excluyen los impuestos aplicables.",
    "freeTrial": {
      "title": "Empieza con una prueba gratuita de 30 días",
      "description": "No se cobrará nada hasta que finalice la prueba. Obtén gratis tu primer mes de insights de empleados."
    },
    "employeeCount": {
      "title": "Número de empleados",
      "hrisConnected": "HRIS conectado",
      "pendingHrisSync": "Sincronización HRIS pendiente",
      "readonlyCount": "{{count}} empleados",
      "description": "El número de puestos de empleados es dinámico y se basa en la cantidad de usuarios activos sincronizados desde tu sistema HRIS que reciben preguntas."
    },
    "plans": {
      "recommended": "Recomendado",
      "perEmployeeMonth": "por empleado / mes",
      "employeeCountFormula": "{{count}} empleados",
      "monthlyTotal": "Total mensual",
      "perMonth": "/ mes",
      "launchingCheckout": "Iniciando checkout...",
      "monthly": {
        "title": "Plan mensual",
        "subtitle": "Facturado mensualmente",
        "cta": "Seleccionar plan mensual"
      },
      "annual": {
        "title": "Plan anual",
        "subtitle": "Facturado anualmente",
        "cta": "Seleccionar plan anual",
        "savingsBadge": "Ahorra {{percent}} %",
        "savingsText": "Ahorra {{amount}}/año con {{count}} empleados"
      }
    },
    "features": {
      "title": "Todas las funciones incluidas en ambos planes",
      "comingSoon": "Próximamente",
      "items": {
        "dailyQuestionDelivery": "Entrega diaria de preguntas",
        "enterpriseSecurity": "Seguridad de nivel empresarial",
        "slackTeamsIntegration": "Integración con Slack y Teams",
        "analyticsDashboard": "Panel de analíticas completo",
        "teamInsights": "Insights de equipo ilimitados",
        "hrisIntegration": "Integración HRIS",
        "dedicatedSupport": "Soporte dedicado",
        "surveyBuilder": "Constructor de encuestas"
      }
    },
    "socialProof": {
      "title": "Por qué las organizaciones eligen feedback continuo",
      "cards": {
        "turnover": {
          "description": "Menores tasas de rotación en organizaciones con feedback regular",
          "source": "Gallup, 2023"
        },
        "managerEffectiveness": {
          "description": "Mayor efectividad de los managers con insights continuos de empleados",
          "source": "Harvard Business Review, 2022"
        },
        "profitMargins": {
          "description": "Mayores márgenes de beneficio en empresas que usan sistemas de feedback continuo",
          "source": "PwC, 2023"
        }
      }
    },
    "invoiceFooter": "¿Necesitas facturación por factura? Contáctanos en <supportLink>support@chirpee.co</supportLink>",
    "complete": {
      "title": "Configuración del pago",
      "description": "Se está confirmando la configuración del pago. Vuelve a Primeros pasos para continuar el onboarding."
    },
    "errors": {
      "chooseCurrency": "Elige una moneda de facturación antes de continuar.",
      "stripeKeyMissing": "La clave publicable de Stripe no está configurada.",
      "checkoutStartFailed": "No se pudo iniciar el checkout. Inténtalo de nuevo.",
      "setupLoadFailed": "No pudimos cargar los detalles de configuración de facturación.",
      "retry": "Reintentar",
      "pricingUnavailable": "Los precios no están disponibles para {{currency}}. Selecciona otra moneda."
    }
  }
}
